<template>
    <div class="panel">
        <div class="panel-heading message-header">
            Register an App
            <hcp-help>Use A phone application like Google Authenticator (IOS or Android) every time you log in.</hcp-help>
        </div>
        <div class="panel-block is-block">
            <error-notifications :errors="errors"></error-notifications>
            <hcp-notification type="is-success" :message.sync="successMessage"></hcp-notification>
            <form v-on:submit.prevent="register">
                <figure class="image level">
                    <div class="level-item"></div>
                    <VueQrcode class="level-item is-narrow" :value="totp.toString()" :options="{ width: 200 }" alt="QR Code"></VueQrcode>
                    <div class="level-item"></div>
                </figure>
                <div class="field">
                    <label class="label" for="token">Token</label>
                    <div class="field has-addons">
                        <div class="control has-icons-left">
                            <input id="token" class="input" type="number" name="token" v-model="token" required>
                            <span class="icon is-small is-left">
                            <i class="fas fa-mobile"></i>
                        </span>
                        </div>
                        <div class="control">
                            <input type="submit" class="button is-primary" value="Verify">
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import urls from "../../urls";
    const OTPAuth = require('otpauth');
    import VueQrcode from "@chenfengyuan/vue-qrcode";
    import HcpHelp from "../HcpHelp";
    import HcpNotification from "../HcpNotification";
    import ErrorNotifications from "heat-shared/src/components/ErrorNotifications";

    export default {
        name: "RegisterTotpApp",
        components: {HcpHelp, HcpNotification, ErrorNotifications, VueQrcode},
        data: function () {
            return {
                'errors': [],
                'token': '',
                // 'secret': OTPAuth.Secret().gethex(),
                'secret': this.getRandom(),
                'digits': '6',
                'successMessage': '',
            }
        },
        props: {
            'username': String,
            'issuer': String,
        },
        computed: {
            totp: function () {
                return new OTPAuth.TOTP({
                    issuer: this.issuer,
                    digits: this.digits,
                    secret: OTPAuth.Secret.fromHex(this.secret)
                });
            },
        },
        methods: {
            //Get a string of random hex encoded bytes (0x00 to 0xFF)
            //The TOTP app for Django recommends 20 bytes
            'getRandom': function () {
                let byteArray = new Uint8Array(20);
                window.crypto.getRandomValues(byteArray);
                let hexArray = [...byteArray].map((x) => ('0' + x.toString(16)).slice(-2));
                return hexArray.join('');
            },
            //If the token is valid or not
            validateToken: function () {
                return !(this.totp.validate({
                    token: this.token,
                    window: 2
                }) === null)
            },
            async register() {
                //if (!this.validateToken()) {
                //    this.errors = ['Token does not match'];
                //    return
                //}
                this.errors = [];
                try {
                    let response = await axios.post(urls['two_factor_device'],
                        {
                            'type': 'app',
                            'token': this.token,
                            'data': this.secret,
                        },
                        {'Content-type': 'application/json'});
                    if (response.data['id']) {
                        this.successMessage = "You have successfully added an App.";
                        this.$store.commit('clearMessages');
                        await this.$store.dispatch('user/getTwoFactorDevices');
                        let redirect_to = this.$route.query.next || null;
                        if(redirect_to !== null){
                            this.$router.push(redirect_to);
                        }
                    }
                } catch (error) {
                    if (error.response.status === 500) {
                        this.errors.push([`Oops: Our system broke while trying to do that!<br>${error.response.data}`]);
                        return;
                    }
                    this.errors = Object.values(error.response.data);
                }
            }
        }
    }
</script>

<style scoped>

</style>
